import { PersonCircleWrap } from "./styles";

const RepCircle = ({
  name,
  onClick,
  small,
  isSelected,
  orderCount = 0
}: {
  name: string;
  onClick?: any;
  small?: boolean;
  isSelected?: boolean;
  orderCount?: number;
}) => {
  return (
    <PersonCircleWrap className="personCircle" onClick={onClick} isSelected={isSelected}>
      <span className={small ? "smallName" : ""}>{name}</span>
      {orderCount > 0 && <div className="orderCountBadge">{orderCount}</div>}
    </PersonCircleWrap>
  );
};

export default RepCircle;
